<router-outlet />
@if(appService.isLoading$()) {
<div
  class="absolute w-full h-full left-0 top-0 z-50 flex items-center justify-center pointer-events-auto"
>
  <mat-spinner />
</div>
}
